import * as React from 'react'
import { StyledRow, StyledCell, StyledText, StyledCellTitle } from '$views/Cookies/Cookies.style'

export const TableCookies: React.SFC = () => {
  return (
    <table>
      <StyledRow>
        <StyledCellTitle columnPosition="left">
          <StyledText color="white" weight="medium">
            Nombre
          </StyledText>
        </StyledCellTitle>
        <StyledCellTitle columnPosition="center">
          <StyledText color="white" weight="medium">
            Dominio
          </StyledText>
        </StyledCellTitle>
        <StyledCellTitle columnPosition="right">
          <StyledText color="white" weight="medium">
            Descripción
          </StyledText>
        </StyledCellTitle>
      </StyledRow>
      <StyledRow>
        <StyledCell>
          <StyledText>__adroll</StyledText>
        </StyledCell>
        <StyledCell>
          <StyledText>.adroll.com</StyledText>
        </StyledCell>
        <StyledCell>
          <StyledText>
            Identificar a los visitantes por dispositivos. Es usada en tiempo real para mostrar anuncios
          </StyledText>
        </StyledCell>
      </StyledRow>
      <StyledRow>
        <StyledCell>
          <StyledText>__adroll_shared</StyledText>
        </StyledCell>
        <StyledCell>
          <StyledText>.adroll.com</StyledText>
        </StyledCell>
        <StyledCell>
          <StyledText>
            Identificar a los visitantes por dispositivos. Es usada en tiempo real para mostrar anuncios
          </StyledText>
        </StyledCell>
      </StyledRow>
      <StyledRow>
        <StyledCell>
          <StyledText>_fbp</StyledText>
        </StyledCell>
        <StyledCell>
          <StyledText>.facebook.com</StyledText>
        </StyledCell>
        <StyledCell>
          <StyledText>Utilizada por Facebook para proporcionar una serie de productos publicitarios</StyledText>
        </StyledCell>
      </StyledRow>
      <StyledRow>
        <StyledCell>
          <StyledText>datr</StyledText>
        </StyledCell>
        <StyledCell>
          <StyledText>.facebook.com</StyledText>
        </StyledCell>
        <StyledCell>
          <StyledText>Utilizada por Facebook para proporcionar una serie de productos publicitarios</StyledText>
        </StyledCell>
      </StyledRow>
      <StyledRow>
        <StyledCell>
          <StyledText>fr</StyledText>
        </StyledCell>
        <StyledCell>
          <StyledText>.facebook.com</StyledText>
        </StyledCell>
        <StyledCell>
          <StyledText>Utilizada por Facebook para proporcionar una serie de productos publicitarios</StyledText>
        </StyledCell>
      </StyledRow>
      <StyledRow>
        <StyledCell>
          <StyledText>IDE</StyledText>
        </StyledCell>
        <StyledCell>
          <StyledText>.doubleclick.net</StyledText>
        </StyledCell>
        <StyledCell>
          <StyledText>
            Utilizada por Google DoubleClick para registrar e informar sobre las acciones del usuario en el sitio web
            tras visualizar o hacer clic en uno de los anuncios del anunciante con el propósito de medir la eficacia de
            un anuncio y presentar anuncios específicos para el usuario
          </StyledText>
        </StyledCell>
      </StyledRow>
      <StyledRow>
        <StyledCell>
          <StyledText>DSID</StyledText>
        </StyledCell>
        <StyledCell>
          <StyledText>.doubleclick.net</StyledText>
        </StyledCell>
        <StyledCell>
          <StyledText>
            Identifica que un usuario tenga la sesión iniciada en sitios que no son de Google y para recordar si el
            usuario ha aceptado la personalización de anuncios
          </StyledText>
        </StyledCell>
      </StyledRow>
      <StyledRow>
        <StyledCell>
          <StyledText>scfc</StyledText>
        </StyledCell>
        <StyledCell>
          <StyledText>.stripe.com</StyledText>
        </StyledCell>
        <StyledCell>
          <StyledText>Soluciona bugs limpiando la cache del navegador</StyledText>
        </StyledCell>
      </StyledRow>
      <StyledRow>
        <StyledCell>
          <StyledText>__stripe_mid</StyledText>
        </StyledCell>
        <StyledCell>
          <StyledText>.stripe.com</StyledText>
        </StyledCell>
        <StyledCell>
          <StyledText>Cookie usada para prevenir posibles fraudes</StyledText>
        </StyledCell>
      </StyledRow>
      <StyledRow>
        <StyledCell>
          <StyledText>__stripe_orig_props</StyledText>
        </StyledCell>
        <StyledCell>
          <StyledText>.stripe.com</StyledText>
        </StyledCell>
        <StyledCell>
          <StyledText>Cookie usada para saber desde donde se ha accedido a stripe</StyledText>
        </StyledCell>
      </StyledRow>
      <StyledRow>
        <StyledCell>
          <StyledText>country</StyledText>
        </StyledCell>
        <StyledCell>
          <StyledText>.stripe.com</StyledText>
        </StyledCell>
        <StyledCell>
          <StyledText>Guarda el código del pais determinado por la IP</StyledText>
        </StyledCell>
      </StyledRow>
      <StyledRow>
        <StyledCell>
          <StyledText>lang</StyledText>
        </StyledCell>
        <StyledCell>
          <StyledText>.stripe.com</StyledText>
        </StyledCell>
        <StyledCell>
          <StyledText>Determina el código de idioma</StyledText>
        </StyledCell>
      </StyledRow>
      <StyledRow>
        <StyledCell>
          <StyledText>docs.prefs</StyledText>
        </StyledCell>
        <StyledCell>
          <StyledText>.stripe.com</StyledText>
        </StyledCell>
        <StyledCell>
          <StyledText>Recuerda preferencias de los documentos visitados</StyledText>
        </StyledCell>
      </StyledRow>
      <StyledRow>
        <StyledCell>
          <StyledText>private_machine_identifier</StyledText>
        </StyledCell>
        <StyledCell>
          <StyledText>.stripe.com</StyledText>
        </StyledCell>
        <StyledCell>
          <StyledText>Identificador de sesión único privado</StyledText>
        </StyledCell>
      </StyledRow>
      <StyledRow>
        <StyledCell>
          <StyledText>machine_identifier</StyledText>
        </StyledCell>
        <StyledCell>
          <StyledText>.stripe.com</StyledText>
        </StyledCell>
        <StyledCell>
          <StyledText>Identificador de sesión único</StyledText>
        </StyledCell>
      </StyledRow>
      <StyledRow>
        <StyledCell>
          <StyledText>_hjSessionUser_XX</StyledText>
        </StyledCell>
        <StyledCell>
          <StyledText>.hotjar.com</StyledText>
        </StyledCell>
        <StyledCell>
          <StyledText>Identificador de sesión del usuario</StyledText>
        </StyledCell>
      </StyledRow>
      <StyledRow>
        <StyledCell>
          <StyledText>ajs_anonymous_id</StyledText>
        </StyledCell>
        <StyledCell>
          <StyledText>.hotjar.com</StyledText>
        </StyledCell>
        <StyledCell>
          <StyledText>Ayuda a contar cuantas personas visitan un sitio determinado</StyledText>
        </StyledCell>
      </StyledRow>
      <StyledRow>
        <StyledCell>
          <StyledText>ajs_user_id</StyledText>
        </StyledCell>
        <StyledCell>
          <StyledText>.hotjar.com</StyledText>
        </StyledCell>
        <StyledCell>
          <StyledText>Ayuda a trackear el uso del usuario</StyledText>
        </StyledCell>
      </StyledRow>
      <StyledRow>
        <StyledCell>
          <StyledText>_hjKB</StyledText>
        </StyledCell>
        <StyledCell>
          <StyledText>.hotjar.com</StyledText>
        </StyledCell>
        <StyledCell>
          <StyledText>Recoger datos analiticos</StyledText>
        </StyledCell>
      </StyledRow>
      <StyledRow>
        <StyledCell>
          <StyledText>_ga</StyledText>
        </StyledCell>
        <StyledCell>
          <StyledText>.hotjar.com</StyledText>
        </StyledCell>
        <StyledCell>
          <StyledText>Recoger datos analiticos</StyledText>
        </StyledCell>
      </StyledRow>
      <StyledRow>
        <StyledCell>
          <StyledText>li_mc</StyledText>
        </StyledCell>
        <StyledCell>
          <StyledText>.linkedin.com</StyledText>
        </StyledCell>
        <StyledCell>
          <StyledText>Se utiliza como caché temporal para evitar la búsqueda en bases de datos</StyledText>
        </StyledCell>
      </StyledRow>
      <StyledRow>
        <StyledCell>
          <StyledText>lang</StyledText>
        </StyledCell>
        <StyledCell>
          <StyledText>.linkedin.com</StyledText>
        </StyledCell>
        <StyledCell>
          <StyledText>Se utiliza para recordar la configuración de idioma de un usuario</StyledText>
        </StyledCell>
      </StyledRow>
      <StyledRow>
        <StyledCell>
          <StyledText>_guid</StyledText>
        </StyledCell>
        <StyledCell>
          <StyledText>.linkedin.com</StyledText>
        </StyledCell>
        <StyledCell>
          <StyledText>
            Se utiliza para identificar a un miembro de LinkedIn para fines publicitarios a través de Google Ads
          </StyledText>
        </StyledCell>
      </StyledRow>
      <StyledRow>
        <StyledCell>
          <StyledText>_gcl_au</StyledText>
        </StyledCell>
        <StyledCell>
          <StyledText>.linkedin.com</StyledText>
        </StyledCell>
        <StyledCell>
          <StyledText>
            Se utiliza para medir el rendimiento de la campaña y de los anuncios, así como las tasas de conversión para
            los anuncios de Google en un sitio visitado
          </StyledText>
        </StyledCell>
      </StyledRow>
      <StyledRow>
        <StyledCell>
          <StyledText>aam_uuid</StyledText>
        </StyledCell>
        <StyledCell>
          <StyledText>.linkedin.com</StyledText>
        </StyledCell>
        <StyledCell>
          <StyledText>Establece la sincronización de ID para Adobe Audience Manager</StyledText>
        </StyledCell>
      </StyledRow>
      <StyledRow>
        <StyledCell>
          <StyledText>VID</StyledText>
        </StyledCell>
        <StyledCell>
          <StyledText>.linkedin.com</StyledText>
        </StyledCell>
        <StyledCell>
          <StyledText>
            ID asociado con un visitante de un micrositio de LinkedIn que se utiliza para determinar conversiones con
            fines de generación de posibles clientes
          </StyledText>
        </StyledCell>
      </StyledRow>
      <StyledRow>
        <StyledCell>
          <StyledText>liap</StyledText>
        </StyledCell>
        <StyledCell>
          <StyledText>.linkedin.com</StyledText>
        </StyledCell>
        <StyledCell>
          <StyledText>
            Utilizada por dominios distintos a www para indicar el estado registrado de un miembro
          </StyledText>
        </StyledCell>
      </StyledRow>
      <StyledRow>
        <StyledCell>
          <StyledText>lms_analytics</StyledText>
        </StyledCell>
        <StyledCell>
          <StyledText>.linkedin.com</StyledText>
        </StyledCell>
        <StyledCell>
          <StyledText>
            Se utiliza para identificar a los miembros de LinkedIn fuera de LinkedIn, con fines analíticos
          </StyledText>
        </StyledCell>
      </StyledRow>
      <StyledRow>
        <StyledCell>
          <StyledText>lidc</StyledText>
        </StyledCell>
        <StyledCell>
          <StyledText>.linkedin.com</StyledText>
        </StyledCell>
        <StyledCell>
          <StyledText>Para facilitar la selección del centro de datos</StyledText>
        </StyledCell>
      </StyledRow>
      <StyledRow>
        <StyledCell>
          <StyledText>mbox</StyledText>
        </StyledCell>
        <StyledCell>
          <StyledText>.linkedin.com</StyledText>
        </StyledCell>
        <StyledCell>
          <StyledText>Utilizada por Adobe Target para analizar la relevancia del contenido online</StyledText>
        </StyledCell>
      </StyledRow>
      <StyledRow>
        <StyledCell>
          <StyledText>bcookie</StyledText>
        </StyledCell>
        <StyledCell>
          <StyledText>.linkedin.com</StyledText>
        </StyledCell>
        <StyledCell>
          <StyledText>
            Cookie de identificador del navegador para identificar los dispositivos que acceden a LinkedIn y detectar
            abuso en la plataforma
          </StyledText>
        </StyledCell>
      </StyledRow>
      <StyledRow>
        <StyledCell>
          <StyledText>lms_ads</StyledText>
        </StyledCell>
        <StyledCell>
          <StyledText>.linkedin.com</StyledText>
        </StyledCell>
        <StyledCell>
          <StyledText>
            Se utiliza para identificar a los miembros de LinkedIn fuera de LinkedIn, con fines publicitarios
          </StyledText>
        </StyledCell>
      </StyledRow>
      <StyledRow>
        <StyledCell>
          <StyledText>li_gc</StyledText>
        </StyledCell>
        <StyledCell>
          <StyledText>.linkedin.com</StyledText>
        </StyledCell>
        <StyledCell>
          <StyledText>
            Se utiliza para almacenar el consentimiento de los invitados con respecto al uso de cookies para fines no
            esenciales
          </StyledText>
        </StyledCell>
      </StyledRow>
      <StyledRow>
        <StyledCell>
          <StyledText>UserMatchHistory</StyledText>
        </StyledCell>
        <StyledCell>
          <StyledText>.linkedin.com</StyledText>
        </StyledCell>
        <StyledCell>
          <StyledText>Sincronización de ID de LinkedIn Ads</StyledText>
        </StyledCell>
      </StyledRow>
    </table>
  )
}



// WEBPACK FOOTER //
// ./src/views/Cookies/components/TableCookies.tsx